import { ROLE_TYPES } from 'utils/permissions';

export const PAYSHEETS_PERMISSIONS = {
  exportData: [ROLE_TYPES.ceo, ROLE_TYPES.finance_specialist],
  updateData: [ROLE_TYPES.ceo, ROLE_TYPES.finance_specialist],
};
